import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shop-products',
  templateUrl: './shop-products.component.html',
  styleUrls: ['./shop-products.component.css'],
  standalone: false,
})
export class ShopProductsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }


}
